import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import { mediaQueries } from '@general/breakpoints';
import NotificationBanner from '@molecules/NotificationBanner';
import { BodySmall, DividerLightGreyStyled, DivWithShadowAlternate, H4, H5 } from '@react/styledComponents';
import ICSCAvatar from './ICSCAvatar';

const ContainerStyled = styled(DivWithShadowAlternate)`
    height: 400px;
    padding: 24px;
    overflow-y: auto;

    @media ${mediaQueries.md} {
        height: 100%;
    }
`;

const BodyStyled = styled(BodySmall)`
    font-weight: 500;
`;

const AnnouncementContent = ({ announcement, isFirstLoad }) => {
    const [showNotificationBanner, setShowNotificationBanner] = useState(true);

    if (!announcement) {
        return <ContainerStyled>{isFirstLoad ? 'Loading...' : 'No results found.'}</ContainerStyled>;
    }

    return (
        <ContainerStyled>
            {showNotificationBanner && (
                <div className="mb-1.5rem">
                    <NotificationBanner dismissible handleDismiss={() => setShowNotificationBanner(false)}>
                        Any and all announcement attachments can be viewed on an event page in the document library
                        section.
                    </NotificationBanner>
                </div>
            )}

            <H4>{announcement.subject}</H4>
            <DividerLightGreyStyled className="mt-1.5rem mb-1.5rem" />

            <div className="flex items-center" style={{ gap: '12px' }}>
                <ICSCAvatar />
                <H5>ICSC</H5>
            </div>

            <div style={{ marginLeft: '52px', marginTop: '16px' }}>
                <BodyStyled dangerouslySetInnerHTML={{ __html: announcement.body }} />
            </div>
        </ContainerStyled>
    );
};

AnnouncementContent.propTypes = {
    announcement: PropTypes.shape({
        subject: PropTypes.string.isRequired,
        body: PropTypes.string.isRequired,
    }),
    isFirstLoad: PropTypes.bool.isRequired,
};

export default AnnouncementContent;
